var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Auth, Layout, Dependencies } from '~/core/decorator';
import { PageService } from '~/utils/page.service';
import { SortService } from '~/utils/sort.service';
import { FlowTaskService } from '~/services/domain-service/flow-task.service';
import ProcessConfigCommon from '~/components/process-config/process-config-common.vue';
var ApprovalTask = /** @class */ (function (_super) {
    __extends(ApprovalTask, _super);
    function ApprovalTask() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modifyData = {};
        _this.searchModel = {
            taskName: '',
            applyCategory: '',
            commonState: '',
        };
        _this.dataSet = [];
        _this.dialog = {
            processConfigCommon: false,
        };
        return _this;
    }
    /**
     * 点击修改按钮
     */
    ApprovalTask.prototype.modifyFlowTask = function (row) {
        this.modifyData = row;
        this.dialog.processConfigCommon = true;
    };
    ApprovalTask.prototype.created = function () {
        this.refreshData();
    };
    ApprovalTask.prototype.refreshData = function () {
        var _this = this;
        this.flowTaskService
            .queryFlowTask(this.searchModel, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    /**
     * 点击新增流程按钮
     */
    ApprovalTask.prototype.addTaskClick = function () {
        this.modifyData = {};
        this.dialog.processConfigCommon = true;
    };
    /**
     * 关闭流程配置
     */
    ApprovalTask.prototype.closeProcessConfig = function () {
        this.dialog.processConfigCommon = false;
        this.refreshData();
    };
    __decorate([
        Dependencies(PageService)
    ], ApprovalTask.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], ApprovalTask.prototype, "sortService", void 0);
    __decorate([
        Dependencies(FlowTaskService)
    ], ApprovalTask.prototype, "flowTaskService", void 0);
    ApprovalTask = __decorate([
        Auth(1703),
        Layout('workspace'),
        Component({
            components: {
                ProcessConfigCommon: ProcessConfigCommon,
            },
        })
    ], ApprovalTask);
    return ApprovalTask;
}(Vue));
export default ApprovalTask;
